import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const raw = localStorage.getItem("ss_auth");
    return raw ? JSON.parse(raw) : null;
  });

  const login = useCallback(async (password, extra = {}) => {
    const { data } = await api.post("/auth/login", { password, ...extra });
    localStorage.setItem("ss_token", data.token);
    const session = { role: data.role, client_id: data.client_id, client_name: data.client_name };
    localStorage.setItem("ss_auth", JSON.stringify(session));
    setAuth(session);
    return session;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ss_token");
    localStorage.removeItem("ss_auth");
    setAuth(null);
  }, []);

  const value = useMemo(() => ({ auth, login, logout }), [auth, login, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
